export default "__VITE_ASSET__JCEsBHWG__"